import { useTranslation } from 'next-i18next'
import { css } from '@emotion/react'

import Link from '@/components/common/Link'

import { LinkWrapper } from './AppleButton.styled'

interface Props {
  dark?: boolean
}

function AppleButton(props: Props) {
  const { dark = false } = props
  const { t } = useTranslation('common')

  return (
    <Link href="https://apps.apple.com/pl/app/navipay/id1455350141" passHref>
      <LinkWrapper
        target="_blank"
        rel="noopener noreferrer nofollow"
        aria-label={t('a11y.appleButton')}
      >
        {dark ? (
          <img
            src={
              'https://cdn.naviparking.com/digital_parking/assets/apple-dark.svg'
            }
            css={imageStyle}
            alt="Apple button"
          />
        ) : (
          <img
            src={
              'https://cdn.naviparking.com/digital_parking/assets/apple-light.svg'
            }
            css={imageStyle}
            alt="Apple button"
          />
        )}
      </LinkWrapper>
    </Link>
  )
}

const imageStyle = css`
  width: 100%;
  height: 100%;
`

export default AppleButton
